var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowSm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "26px",
    viewBox: "0 0 13 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 103") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-103",
    transform: "translate(6.599157, 12.000000) scale(-1, 1) rotate(-90.000000) translate(-6.599157, -12.000000) translate(-5.134728, 7.134728)",
    stroke: "#000000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("line", {
    x1: 1.03238906,
    y1: 4.73054437,
    x2: 22.4881254,
    y2: 4.75090088,
    id: "Line-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -3.62848903e-17,
    y1: 4.73054437,
    x2: 4.73054437,
    y2: 9.09494702e-13,
    id: "Line-7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -3.62848903e-17,
    y1: 9.73054437,
    x2: 4.73388446,
    y2: 4.99665991,
    id: "Line-7",
    transform: "translate(2.500000, 7.230544) scale(1, -1) translate(-2.500000, -7.230544) "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSm);
export default __webpack_public_path__ + "static/media/arrow-sm.89d29875972c41603017e74095fc3f97.svg";
export { ForwardRef as ReactComponent };